// import { useState, useEffect, useRef } from 'react';
// import { Link } from 'react-router-dom';
// import withAuth from '../../auth/WithAuth';
// import './projectmanagement.scss';
// import FurnitureNavbar from '../../../components/layout/Nav';
// import { serverUrlAuth } from '../../../serverUrl';

// const ProjectManagement = () => {
//   const [projectsData, setProjectsData] = useState({
//     total_projects: 0,
//     open_projects: 0,
//     active_projects: 0,
//     completed_projects: 0,
//     projects: [],
//   });
//   const [loading, setLoading] = useState(true);
//   const [filters, setFilters] = useState({
//     status: 'all',
//     search: '',
//     category: 'all',
//     budgetRange: 'all',
//   });
//   const [currentImageIndices, setCurrentImageIndices] = useState({});

//   const fetchProjectManagementData = async () => {
//     try {
//       const response = await serverUrlAuth.get(
//         'projects/admin/project-management/'
//       );
//       setProjectsData(response.data);
//       const initialIndices = {};
//       response.data.projects.forEach((project) => {
//         if (project.images && project.images.length > 0) {
//           initialIndices[project.id] = 0;
//         }
//       });
//       setCurrentImageIndices(initialIndices);
//       setLoading(false);
//     } catch (error) {
//       console.error(error);
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchProjectManagementData();
//   }, []);

//   const nextImage = (projectId) => {
//     const project = projectsData.projects.find((p) => p.id === projectId);
//     if (!project || !project.images || project.images.length <= 1) return;

//     setCurrentImageIndices((prev) => ({
//       ...prev,
//       [projectId]: (prev[projectId] + 1) % project.images.length,
//     }));
//   };

//   const prevImage = (projectId) => {
//     const project = projectsData.projects.find((p) => p.id === projectId);
//     if (!project || !project.images || project.images.length <= 1) return;

//     setCurrentImageIndices((prev) => ({
//       ...prev,
//       [projectId]:
//         (prev[projectId] - 1 + project.images.length) % project.images.length,
//     }));
//   };

//   const setImageIndex = (projectId, index) => {
//     setCurrentImageIndices((prev) => ({
//       ...prev,
//       [projectId]: index,
//     }));
//   };

//   const filteredProjects = projectsData.projects.filter((project) => {
//     if (filters.status !== 'all' && project.status !== filters.status)
//       return false;
//     if (filters.category !== 'all' && project.category !== filters.category)
//       return false;

//     if (filters.budgetRange !== 'all') {
//       const budget = project.budget;
//       switch (filters.budgetRange) {
//         case 'low':
//           if (budget > 20000) return false;
//           break;
//         case 'medium':
//           if (budget <= 20000 || budget > 50000) return false;
//           break;
//         case 'high':
//           if (budget <= 50000) return false;
//           break;
//       }
//     }

//     if (
//       filters.search &&
//       !project.title.toLowerCase().includes(filters.search.toLowerCase()) &&
//       !project.client.toLowerCase().includes(filters.search.toLowerCase()) &&
//       !project.description.toLowerCase().includes(filters.search.toLowerCase())
//     )
//       return false;

//     return true;
//   });

//   const getStatusInfo = (status) => {
//     const info = {
//       open: { color: '#f59e0b', icon: '🔓', label: 'Open' },
//       'in-progress': { color: '#3b82f6', icon: '⚡', label: 'In Progress' },
//       completed: { color: '#10b981', icon: '✅', label: 'Completed' },
//       'awaiting-deposit-payment': { color: '#8b5cf6', icon: '💳', label: 'Awaiting Deposit' },
//       'awaiting-final-payment': { color: '#ec4899', icon: '💳', label: 'Awaiting Final' },
//       cancelled: { color: '#ef4444', icon: '❌', label: 'Cancelled' },
//     };
//     return info[status] || { color: '#6b7280', icon: '❓', label: 'Unknown' };
//   };

//   const handleBulkAction = (action) => {
//     alert(`Bulk action: ${action} selected`);
//   };

//   return (
//     <>
//       <FurnitureNavbar />
//       <div className="admin-projects">
//         {/* Page Header */}
//         <div className="page-header">
//           <div className="header-content">
//             <div className="header-text">
//               <h1>📋 Projects Management</h1>
//               <p>Monitor and manage all projects on the platform</p>
//             </div>
//             <div className="header-actions">
//               <button
//                 className="btn btn-primary"
//                 onClick={() => handleBulkAction('export')}
//               >
//                 📊 Export Report
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* Stats Overview */}
//         <div className="stats-overview">
//           <div className="stat-card total-projects">
//             <div className="stat-content">
//               <div className="stat-icon">📋</div>
//               <div className="stat-info">
//                 <h3>Total Projects</h3>
//                 <p className="stat-value">{projectsData.total_projects}</p>
//               </div>
//             </div>
//           </div>
//           <div className="stat-card open-projects">
//             <div className="stat-content">
//               <div className="stat-icon">🔓</div>
//               <div className="stat-info">
//                 <h3>Open</h3>
//                 <p className="stat-value">{projectsData.open_projects}</p>
//                 <span className="stat-change neutral">Seeking artisans</span>
//               </div>
//             </div>
//           </div>
//           <div className="stat-card awaiting-deposit">
//             <div className="stat-content">
//               <div className="stat-icon">💳</div>
//               <div className="stat-info">
//                 <h3>Awaiting Deposit</h3>
//                 <p className="stat-value">{projectsData.awaiting_deposit_projects || 0}</p>
//                 <span className="stat-change neutral">Pending payment</span>
//               </div>
//             </div>
//           </div>
//           <div className="stat-card progress-projects">
//             <div className="stat-content">
//               <div className="stat-icon">⚡</div>
//               <div className="stat-info">
//                 <h3>In Progress</h3>
//                 <p className="stat-value">{projectsData.active_projects}</p>
//                 <span className="stat-change positive">Active work</span>
//               </div>
//             </div>
//           </div>
//           <div className="stat-card awaiting-final">
//             <div className="stat-content">
//               <div className="stat-icon">💳</div>
//               <div className="stat-info">
//                 <h3>Awaiting Final</h3>
//                 <p className="stat-value">{projectsData.awaiting_final_projects || 0}</p>
//                 <span className="stat-change neutral">Pending final payment</span>
//               </div>
//             </div>
//           </div>
//           <div className="stat-card completed-projects">
//             <div className="stat-content">
//               <div className="stat-icon">✅</div>
//               <div className="stat-info">
//                 <h3>Completed</h3>
//                 <p className="stat-value">{projectsData.completed_projects}</p>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Filters Section */}
//         <div className="filters-section">
//           <div className="filters-bar">
//             <div className="search-box">
//               <input
//                 type="text"
//                 placeholder="Search projects by title, client, or description..."
//                 value={filters.search}
//                 onChange={(e) =>
//                   setFilters((prev) => ({ ...prev, search: e.target.value }))
//                 }
//               />
//               <span className="search-icon">🔍</span>
//             </div>

//             <div className="filter-group">
//               <select
//                 value={filters.status}
//                 onChange={(e) =>
//                   setFilters((prev) => ({ ...prev, status: e.target.value }))
//                 }
//               >
//                 <option value="all">All Status</option>
//                 <option value="open">Open</option>
//                 <option value="awaiting-deposit-payment">Awaiting Deposit</option>
//                 <option value="in-progress">In Progress</option>
//                 <option value="awaiting-final-payment">Awaiting Final</option>
//                 <option value="completed">Completed</option>
//                 <option value="cancelled">Cancelled</option>
//               </select>

//               <select
//                 value={filters.category}
//                 onChange={(e) =>
//                   setFilters((prev) => ({ ...prev, category: e.target.value }))
//                 }
//               >
//                 <option value="all">All Categories</option>
//                 <option value="furniture">Furniture</option>
//                 <option value="carpentry">Carpentry</option>
//                 <option value="metalwork">Metalwork</option>
//               </select>

//               <select
//                 value={filters.budgetRange}
//                 onChange={(e) =>
//                   setFilters((prev) => ({
//                     ...prev,
//                     budgetRange: e.target.value,
//                   }))
//                 }
//               >
//                 <option value="all">All Budgets</option>
//                 <option value="low">Low (&lt; 20K)</option>
//                 <option value="medium">Medium (20K-50K)</option>
//                 <option value="high">High (&gt; 50K)</option>
//               </select>
//             </div>

//             <div className="filter-actions">
//               <button
//                 className="btn btn-secondary"
//                 onClick={() =>
//                   setFilters({
//                     status: 'all',
//                     search: '',
//                     category: 'all',
//                     budgetRange: 'all',
//                   })
//                 }
//               >
//                 Clear Filters
//               </button>
//               <span className="results-count">
//                 {filteredProjects.length} of {projectsData.projects.length}{' '}
//                 projects
//               </span>
//             </div>
//           </div>
//         </div>

//         {/* Projects Grid */}
//         <div className="projects-section">
//           <div className="section-header">
//             <h3>All Projects</h3>
//             <div className="section-actions">
//               <select
//                 className="bulk-actions"
//                 onChange={(e) => handleBulkAction(e.target.value)}
//                 defaultValue=""
//               >
//                 <option value="" disabled>
//                   Bulk Actions
//                 </option>
//                 <option value="archive">Archive Selected</option>
//                 <option value="export">Export Selected</option>
//                 <option value="notify">Notify Clients</option>
//               </select>
//             </div>
//           </div>

//           <div className="projects-grid">
//             {filteredProjects.map((project) => {
//               const statusInfo = getStatusInfo(project.status);
//               const currentImageIndex = currentImageIndices[project.id] || 0;

//               return (
//                 <div
//                   key={project.id}
//                   className={`project-card ${project.status}`}
//                 >
//                   {/* Project Header */}
//                   <div className="project-header">
//                     <div className="project-title-section">
//                       <h3>{project.title}</h3>
//                       <span className="project-client">by {project.client}</span>
//                     </div>
//                     <div className="project-status">
//                       <span
//                         className="status-badge"
//                         style={{ backgroundColor: statusInfo.color }}
//                       >
//                         <span className="status-icon">{statusInfo.icon}</span>
//                         {statusInfo.label}
//                       </span>
//                     </div>
//                   </div>

//                   {/* Image Carousel */}
//                   {project.images && project.images.length > 0 && (
//                     <div className="image-carousel">
//                       <div className="carousel-container">
//                         <img
//                           src={project.images[currentImageIndex]?.image}
//                           alt={`Project preview ${currentImageIndex + 1}`}
//                           className="main-image"
//                           onClick={() =>
//                             window.open(
//                               project.images[currentImageIndex]?.image,
//                               '_blank'
//                             )
//                           }
//                         />
//                         {project.images.length > 1 && (
//                           <>
//                             <button
//                               className="carousel-btn prev"
//                               onClick={() => prevImage(project.id)}
//                               aria-label="Previous image"
//                             >
//                               ‹
//                             </button>
//                             <button
//                               className="carousel-btn next"
//                               onClick={() => nextImage(project.id)}
//                               aria-label="Next image"
//                             >
//                               ›
//                             </button>
//                             <div className="carousel-dots">
//                               {project.images.map((_, idx) => (
//                                 <button
//                                   key={idx}
//                                   className={`dot ${
//                                     currentImageIndex === idx ? 'active' : ''
//                                   }`}
//                                   onClick={() => setImageIndex(project.id, idx)}
//                                   aria-label={`Go to image ${idx + 1}`}
//                                 />
//                               ))}
//                             </div>
//                             <div className="image-counter">
//                               {currentImageIndex + 1} / {project.images.length}
//                             </div>
//                           </>
//                         )}
//                       </div>
//                     </div>
//                   )}

//                   {/* Project Description */}
//                   <div className="project-description">
//                     <p>{project.description}</p>
//                   </div>

//                   {/* Project Details Grid */}
//                   <div className="project-details-grid">
//                     <div className="detail-item">
//                       <span className="label">📍 Location</span>
//                       <span className="value">{project.location || 'N/A'}</span>
//                     </div>
//                     <div className="detail-item">
//                       <span className="label">📅 Created</span>
//                       <span className="value">
//                         {new Date(project.created_at).toLocaleDateString()}
//                       </span>
//                     </div>
//                     <div className="detail-item">
//                       <span className="label">📅 Deadline</span>
//                       <span className="value deadline">
//                         {new Date(project.deadline).toLocaleDateString()}
//                       </span>
//                     </div>
//                     <div className="detail-item">
//                       <span className="label">💰 Budget</span>
//                       <span className="value budget">
//                         KSh {project.budget?.toLocaleString()}
//                       </span>
//                     </div>
//                     {project.agreed_amount && (
//                       <div className="detail-item">
//                         <span className="label">💰 Agreed Amount</span>
//                         <span className="value agreed-amount">
//                           KSh {project.agreed_amount?.toLocaleString()}
//                         </span>
//                       </div>
//                     )}
//                     <div className="detail-item">
//                       <span className="label">📨 Proposals</span>
//                       <span className="value proposals">
//                         {project.proposal_count || 0}
//                       </span>
//                     </div>
//                     {project.artisan_name && (
//                       <div className="detail-item full-width">
//                         <span className="label">👤 Assigned Artisan</span>
//                         <span className="value artisan-name">
//                           {project.artisan_name}
//                         </span>
//                       </div>
//                     )}
//                     {project.client_phone_number && (
//                       <div className="detail-item full-width">
//                         <span className="label">📞 Client Phone</span>
//                         <span className="value">{project.client_phone_number}</span>
//                       </div>
//                     )}
//                   </div>

//                   {/* Progress Section */}
//                   {project.status === 'in-progress' && project.progress !== undefined && (
//                     <div className="progress-section">
//                       <div className="progress-header">
//                         <span>Progress</span>
//                         <span className="progress-percent">
//                           {project.progress}%
//                         </span>
//                       </div>
//                       <div className="progress-bar">
//                         <div
//                           className="progress-fill"
//                           style={{
//                             width: `${project.progress}%`,
//                             backgroundColor: statusInfo.color,
//                           }}
//                         ></div>
//                       </div>
//                     </div>
//                   )}

//                 </div>
//               );
//             })}
//           </div>

//           {filteredProjects.length === 0 && (
//             <div className="empty-state">
//               <div className="empty-icon">📋</div>
//               <h3>No projects found</h3>
//               <p>
//                 No projects match your current filter criteria. Try adjusting
//                 your search or filters.
//               </p>
//               <button
//                 className="btn btn-primary"
//                 onClick={() =>
//                   setFilters({
//                     status: 'all',
//                     search: '',
//                     category: 'all',
//                     budgetRange: 'all',
//                   })
//                 }
//               >
//                 Clear All Filters
//               </button>
//             </div>
//           )}
//         </div>

//         {/* Footer */}
//         <div className="section-footer">
//           <div className="footer-info">
//             Showing {filteredProjects.length} of {projectsData.projects.length}{' '}
//             projects
//           </div>
//           <div className="pagination">
//             <button className="page-btn" disabled>
//               ← Previous
//             </button>
//             <span className="page-info">Page 1 of 1</span>
//             <button className="page-btn" disabled>
//               Next →
//             </button>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default withAuth(ProjectManagement, 'admin');



// src/pages/admin/ProjectManagement.jsx
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import withAuth from '../../auth/WithAuth';
import './projectmanagement.scss';
import { serverUrlAuth } from '../../../serverUrl';
import {
  FaProjectDiagram,
  FaLockOpen,
  FaBolt,
  FaCheckCircle,
  FaCreditCard,
  FaFileExport,
  FaSearch,
  FaFilter,
  FaTimes,
  FaChevronLeft,
  FaChevronRight,
  FaMapMarkerAlt,
  FaCalendarAlt,
  FaMoneyBillWave,
  FaEnvelope,
  FaUser,
  FaPhone,
} from 'react-icons/fa';
import Sidebar from '../../../components/layout/Sidebar';

const ProjectManagement = () => {
  const [projectsData, setProjectsData] = useState({
    total_projects: 0,
    open_projects: 0,
    active_projects: 0,
    completed_projects: 0,
    projects: [],
  });
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    status: 'all',
    search: '',
    category: 'all',
    budgetRange: 'all',
  });
  const [currentImageIndices, setCurrentImageIndices] = useState({});

  const fetchProjectManagementData = async () => {
    try {
      const response = await serverUrlAuth.get(
        'projects/admin/project-management/'
      );
      setProjectsData(response.data);
      const initialIndices = {};
      response.data.projects.forEach((project) => {
        if (project.images && project.images.length > 0) {
          initialIndices[project.id] = 0;
        }
      });
      setCurrentImageIndices(initialIndices);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProjectManagementData();
  }, []);

  const nextImage = (projectId) => {
    const project = projectsData.projects.find((p) => p.id === projectId);
    if (!project || !project.images || project.images.length <= 1) return;

    setCurrentImageIndices((prev) => ({
      ...prev,
      [projectId]: (prev[projectId] + 1) % project.images.length,
    }));
  };

  const prevImage = (projectId) => {
    const project = projectsData.projects.find((p) => p.id === projectId);
    if (!project || !project.images || project.images.length <= 1) return;

    setCurrentImageIndices((prev) => ({
      ...prev,
      [projectId]:
        (prev[projectId] - 1 + project.images.length) % project.images.length,
    }));
  };

  const setImageIndex = (projectId, index) => {
    setCurrentImageIndices((prev) => ({
      ...prev,
      [projectId]: index,
    }));
  };

  const filteredProjects = projectsData.projects.filter((project) => {
    if (filters.status !== 'all' && project.status !== filters.status)
      return false;
    if (filters.category !== 'all' && project.category !== filters.category)
      return false;

    if (filters.budgetRange !== 'all') {
      const budget = project.budget;
      switch (filters.budgetRange) {
        case 'low':
          if (budget > 20000) return false;
          break;
        case 'medium':
          if (budget <= 20000 || budget > 50000) return false;
          break;
        case 'high':
          if (budget <= 50000) return false;
          break;
      }
    }

    if (
      filters.search &&
      !project.title.toLowerCase().includes(filters.search.toLowerCase()) &&
      !project.client.toLowerCase().includes(filters.search.toLowerCase()) &&
      !project.description.toLowerCase().includes(filters.search.toLowerCase())
    )
      return false;

    return true;
  });

  const getStatusInfo = (status) => {
    const info = {
      open: { color: '#8a5018', icon: '🔓', label: 'Open' },
      'in-progress': { color: '#673200', icon: '⚡', label: 'In Progress' },
      completed: { color: '#6b8e23', icon: '✅', label: 'Completed' },
      'awaiting-deposit-payment': {
        color: '#a86b2e',
        icon: '💳',
        label: 'Awaiting Deposit',
      },
      'awaiting-final-payment': {
        color: '#c98d4f',
        icon: '💳',
        label: 'Awaiting Final',
      },
      cancelled: { color: '#8b2e1a', icon: '❌', label: 'Cancelled' },
    };
    return info[status] || { color: '#8a7a6a', icon: '❓', label: 'Unknown' };
  };

  const handleBulkAction = (action) => {
    alert(`Bulk action: ${action} selected`);
  };

  const clearFilters = () =>
    setFilters({
      status: 'all',
      search: '',
      category: 'all',
      budgetRange: 'all',
    });

  const statCards = [
    {
      key: 'total',
      className: 'total-projects',
      icon: <FaProjectDiagram />,
      label: 'Total Projects',
      value: projectsData.total_projects,
    },
    {
      key: 'open',
      className: 'open-projects',
      icon: <FaLockOpen />,
      label: 'Open',
      value: projectsData.open_projects,
      change: 'Seeking artisans',
      changeType: 'neutral',
    },
    {
      key: 'awaiting-deposit',
      className: 'awaiting-deposit',
      icon: <FaCreditCard />,
      label: 'Awaiting Deposit',
      value: projectsData.awaiting_deposit_projects || 0,
      change: 'Pending payment',
      changeType: 'neutral',
    },
    {
      key: 'in-progress',
      className: 'progress-projects',
      icon: <FaBolt />,
      label: 'In Progress',
      value: projectsData.active_projects,
      change: 'Active work',
      changeType: 'positive',
    },
    {
      key: 'awaiting-final',
      className: 'awaiting-final',
      icon: <FaCreditCard />,
      label: 'Awaiting Final',
      value: projectsData.awaiting_final_projects || 0,
      change: 'Pending final payment',
      changeType: 'neutral',
    },
    {
      key: 'completed',
      className: 'completed-projects',
      icon: <FaCheckCircle />,
      label: 'Completed',
      value: projectsData.completed_projects,
    },
  ];

  return (
    <>
      <Sidebar />
      <div className="admin-projects">
        {/* ============ PAGE HEADER ============ */}
        <div className="page-header">
          <div className="header-content">
            <div className="header-text">
              <span className="eyebrow">Admin · Projects</span>
              <h1>Projects Management</h1>
              <p>Monitor and manage all projects on the platform</p>
            </div>
            <div className="header-actions">
              <button
                className="btn btn-primary"
                onClick={() => handleBulkAction('export')}
              >
                <FaFileExport /> Export Report
              </button>
            </div>
          </div>
        </div>

        {/* ============ STATS ============ */}
        <div className="stats-overview">
          {statCards.map((s) => (
            <div key={s.key} className={`stat-card ${s.className}`}>
              <div className="stat-content">
                <div className="stat-icon">{s.icon}</div>
                <div className="stat-info">
                  <h3>{s.label}</h3>
                  <p className="stat-value">{s.value}</p>
                  {s.change && (
                    <span className={`stat-change ${s.changeType}`}>
                      {s.change}
                    </span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* ============ FILTERS ============ */}
        <div className="filters-section">
          <div className="filters-bar">
            <div className="search-box">
              <FaSearch className="search-icon" />
              <input
                type="text"
                placeholder="Search projects by title, client, or description…"
                value={filters.search}
                onChange={(e) =>
                  setFilters((prev) => ({ ...prev, search: e.target.value }))
                }
              />
            </div>

            <div className="filter-group">
              <select
                value={filters.status}
                onChange={(e) =>
                  setFilters((prev) => ({ ...prev, status: e.target.value }))
                }
              >
                <option value="all">All Status</option>
                <option value="open">Open</option>
                <option value="awaiting-deposit-payment">
                  Awaiting Deposit
                </option>
                <option value="in-progress">In Progress</option>
                <option value="awaiting-final-payment">Awaiting Final</option>
                <option value="completed">Completed</option>
                <option value="cancelled">Cancelled</option>
              </select>

              <select
                value={filters.category}
                onChange={(e) =>
                  setFilters((prev) => ({ ...prev, category: e.target.value }))
                }
              >
                <option value="all">All Categories</option>
                <option value="furniture">Furniture</option>
                <option value="carpentry">Carpentry</option>
                <option value="metalwork">Metalwork</option>
              </select>

              <select
                value={filters.budgetRange}
                onChange={(e) =>
                  setFilters((prev) => ({
                    ...prev,
                    budgetRange: e.target.value,
                  }))
                }
              >
                <option value="all">All Budgets</option>
                <option value="low">Low (&lt; 20K)</option>
                <option value="medium">Medium (20K–50K)</option>
                <option value="high">High (&gt; 50K)</option>
              </select>
            </div>

            <div className="filter-actions">
              <button className="btn btn-secondary" onClick={clearFilters}>
                <FaFilter /> Clear
              </button>
              <span className="results-count">
                {filteredProjects.length} of {projectsData.projects.length}{' '}
                projects
              </span>
            </div>
          </div>
        </div>

        {/* ============ PROJECTS GRID ============ */}
        <div className="projects-section">
          <div className="section-header">
            <h3>All Projects</h3>
            <div className="section-actions">
              <select
                className="bulk-actions"
                onChange={(e) => handleBulkAction(e.target.value)}
                defaultValue=""
              >
                <option value="" disabled>
                  Bulk Actions
                </option>
                <option value="archive">Archive Selected</option>
                <option value="export">Export Selected</option>
                <option value="notify">Notify Clients</option>
              </select>
            </div>
          </div>

          <div className="projects-grid">
            {filteredProjects.map((project) => {
              const statusInfo = getStatusInfo(project.status);
              const currentImageIndex = currentImageIndices[project.id] || 0;

              return (
                <div
                  key={project.id}
                  className={`project-card ${project.status}`}
                >
                  {/* Header */}
                  <div className="project-header">
                    <div className="project-title-section">
                      <h3>{project.title}</h3>
                      <span className="project-client">
                        by {project.client}
                      </span>
                    </div>
                    <div className="project-status">
                      <span
                        className="status-badge"
                        style={{ backgroundColor: statusInfo.color }}
                      >
                        <span className="status-icon">{statusInfo.icon}</span>
                        {statusInfo.label}
                      </span>
                    </div>
                  </div>

                  {/* Carousel */}
                  {project.images && project.images.length > 0 && (
                    <div className="image-carousel">
                      <div className="carousel-container">
                        <img
                          src={project.images[currentImageIndex]?.image}
                          alt={`Project preview ${currentImageIndex + 1}`}
                          className="main-image"
                          onClick={() =>
                            window.open(
                              project.images[currentImageIndex]?.image,
                              '_blank'
                            )
                          }
                        />
                        {project.images.length > 1 && (
                          <>
                            <button
                              className="carousel-btn prev"
                              onClick={() => prevImage(project.id)}
                              aria-label="Previous image"
                            >
                              <FaChevronLeft />
                            </button>
                            <button
                              className="carousel-btn next"
                              onClick={() => nextImage(project.id)}
                              aria-label="Next image"
                            >
                              <FaChevronRight />
                            </button>
                            <div className="carousel-dots">
                              {project.images.map((_, idx) => (
                                <button
                                  key={idx}
                                  className={`dot ${
                                    currentImageIndex === idx ? 'active' : ''
                                  }`}
                                  onClick={() =>
                                    setImageIndex(project.id, idx)
                                  }
                                  aria-label={`Go to image ${idx + 1}`}
                                />
                              ))}
                            </div>
                            <div className="image-counter">
                              {currentImageIndex + 1} / {project.images.length}
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Description */}
                  <div className="project-description">
                    <p>{project.description}</p>
                  </div>

                  {/* Details */}
                  <div className="project-details-grid">
                    <div className="detail-item">
                      <span className="label">
                        <FaMapMarkerAlt /> Location
                      </span>
                      <span className="value">{project.location || 'N/A'}</span>
                    </div>
                    <div className="detail-item">
                      <span className="label">
                        <FaCalendarAlt /> Created
                      </span>
                      <span className="value">
                        {new Date(project.created_at).toLocaleDateString()}
                      </span>
                    </div>
                    <div className="detail-item">
                      <span className="label">
                        <FaCalendarAlt /> Deadline
                      </span>
                      <span className="value deadline">
                        {new Date(project.deadline).toLocaleDateString()}
                      </span>
                    </div>
                    <div className="detail-item">
                      <span className="label">
                        <FaMoneyBillWave /> Budget
                      </span>
                      <span className="value budget">
                        KSh {project.budget?.toLocaleString()}
                      </span>
                    </div>
                    {project.agreed_amount && (
                      <div className="detail-item">
                        <span className="label">
                          <FaMoneyBillWave /> Agreed Amount
                        </span>
                        <span className="value agreed-amount">
                          KSh {project.agreed_amount?.toLocaleString()}
                        </span>
                      </div>
                    )}
                    <div className="detail-item">
                      <span className="label">
                        <FaEnvelope /> Proposals
                      </span>
                      <span className="value proposals">
                        {project.proposal_count || 0}
                      </span>
                    </div>
                    {project.artisan_name && (
                      <div className="detail-item full-width">
                        <span className="label">
                          <FaUser /> Assigned Artisan
                        </span>
                        <span className="value artisan-name">
                          {project.artisan_name}
                        </span>
                      </div>
                    )}
                    {project.client_phone_number && (
                      <div className="detail-item full-width">
                        <span className="label">
                          <FaPhone /> Client Phone
                        </span>
                        <span className="value">
                          {project.client_phone_number}
                        </span>
                      </div>
                    )}
                  </div>

                  {/* Progress */}
                  {project.status === 'in-progress' &&
                    project.progress !== undefined && (
                      <div className="progress-section">
                        <div className="progress-header">
                          <span>Progress</span>
                          <span className="progress-percent">
                            {project.progress}%
                          </span>
                        </div>
                        <div className="progress-bar">
                          <div
                            className="progress-fill"
                            style={{
                              width: `${project.progress}%`,
                              backgroundColor: statusInfo.color,
                            }}
                          ></div>
                        </div>
                      </div>
                    )}
                </div>
              );
            })}
          </div>

          {filteredProjects.length === 0 && (
            <div className="empty-state">
              <div className="empty-icon">
                <FaProjectDiagram />
              </div>
              <h3>No projects found</h3>
              <p>
                No projects match your current filter criteria. Try adjusting
                your search or filters.
              </p>
              <button className="btn btn-primary" onClick={clearFilters}>
                Clear All Filters
              </button>
            </div>
          )}
        </div>

        {/* ============ FOOTER ============ */}
        <div className="section-footer">
          <div className="footer-info">
            Showing {filteredProjects.length} of {projectsData.projects.length}{' '}
            projects
          </div>
          <div className="pagination">
            <button className="page-btn" disabled>
              <FaChevronLeft /> Previous
            </button>
            <span className="page-info">Page 1 of 1</span>
            <button className="page-btn" disabled>
              Next <FaChevronRight />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default withAuth(ProjectManagement, 'admin');